<template>
    <el-container>
        <el-header class="main-header">
            <vHead></vHead>
        </el-header>
        <el-container class="main" style="height:100%;">
            <w-sidebar class="main-slider-menu"/>
            <div class="collapse-nav-icon" @click="collapseFn" :style="{ transform:isCollapse ? 'translate(-116px,0)' : 'translate(0,0)' }">
                <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
            </div>
            <w-router-view :tabMode='true' :isCachePage="false" style=""/>
        </el-container>
    </el-container>
</template>

<script>
    import vHead from '../components/header.vue';

    export default {
        components: {
            vHead
        },
        data(){
          return {
              show:true
          }
        },
        computed:{
            isCollapse(){
                return this.$store.state.isCollapse;
            },
            getSkinName(){
                return this.$store.state.skinName;
            }
        },
        created(){

            this.setSkin();
            this.$store.dispatch('getDictionary');   // 获取全部的数据字典
            this.$store.dispatch('getDictionary2');   // 获取全部的CICD数据字典
            this.$store.dispatch('getCaseType');     // 所有的类型id
            // let user_id=window.localStorage.getItem('userid')
            // this.$store.dispatch('getAuth',{app_name:'itsm',user_id})
        },
        mounted:function () {

        },
	    methods: {
            setSkin(){
                // 设置肤色为亮色;
                let skinName = this.getSkinName;
                let skin = JSON.parse(window.localStorage.getItem(skinName));
                if(typeof skin == Object){
                    // 浏览器中没有肤色字段
                    window.localStorage.setItem(skinName,true);
                }else{
                   // let theme = skin ? 'theme1' : 'theme2';
                    window.document.documentElement.setAttribute('data-theme',"theme1");
                };
            },
            collapseFn(){
                this.$store.commit("setCollapse",!this.isCollapse);
            }
        }
    }
</script>
<style lang="scss" scoped rel="stylesheet/scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
